namespace GeniuzPOS.InventoryReport {
    export class IcReportWhsEomColumns {
        static columnsKey = 'InventoryReport.IcReportWhsEom';
    }
}
